<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "ServicoCreditoContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
	}),
	methods: {
		montarMenu() {
			let m = [];

			if (this.permissao("servico_credito_dashboard")) {
				m.push({
					titulo: "Dashboard",
					titulo_app: "Dashboard",
					icon: "mdi-tag-text",
					to: "/servicocredito",
					tooltip: "Resumo de serviços de crédito",

				});
			}

			if (this.permissao("servico_credito_metas")) {
				m.push({
					titulo: "Metas",
					titulo_app: "Metas",
					icon: "mdi-bullseye-arrow",
					to: "/servicocredito/metas",
					tooltip: "Cadastro de metas",
				});
			}

			if (this.permissao("servico_credito_propostas")) {
				m.push({
					titulo: "Propostas",
					titulo_app: "Propostas",
					icon: "mdi-file-document-edit-outline",
					to: "/servicocredito/propostas",
					tooltip: "Cadastro de propostas",
				});
			}
			
			if (this.permissao("servico_credito_servicos")) {
				m.push({
					titulo: "Serviços",
					titulo_app: "Serviços",
					icon: "mdi-file-document-edit-outline",
					to: "/servicocredito/servicos",
					tooltip: "Serviços Cadastrados",
				});
			}
			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>